import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"

const MediaBlock = styled.figure`
  margin: var(--spacing-xxl) 0;
`

const Label = styled.figcaption`
  display: block;
  width: 100%;
  text-align: center;
  font-size: var(--font-sm);
  color: var(--color-text-inactive);
  margin-top: var(--spacing-s);
`

const BlockMedia = ({ data }) => {
  if (!data?.file) {
    console.warn("BlockMedia: file is undefined, skipping rendering.")
    return
  }

  const isVideo = data.file.mime.startsWith("video")

  return (
    <MediaBlock>
      {isVideo ? (
        <p>TODO video</p>
      ) : (
        <GatsbyImage
          image={getImage(data.file.localFile)}
          alt={data.file.alternativeText}
        />
      )}
      <Label>{data.file.caption}</Label>
    </MediaBlock>
  )
}

export default BlockMedia
